// MOCK DATA for HPR - High Performance Roofing (frontend-only)
// Contact details & prices below are the REAL values provided by the client.

import {
  Droplets, PaintRoller, Sun, ShieldCheck, Sparkles, Leaf, Layers, Wrench,
  ClipboardList, PhoneCall, Headphones,
} from "lucide-react";

export const company = {
  name: "HPR",
  full: "High Performance Roofing",
  phone: "079-055 51 30",
  phoneHref: "tel:+46790555130",
  email: "kontakt@hproofing.se",
  billingEmail: "info@hproofing.se",
  city: "Stockholms län & Uppsala",
  rating: 4.9,
  reviews: 1284,
};

export const nav = [
  { label: "Tjänster", href: "#tjanster" },
  { label: "Takfärgväljare", href: "/takmalning" },
  { label: "Solcellstvätt", href: "/solcellstvatt" },
  { label: "Referenser", href: "/referenser" },
  { label: "Så funkar det", href: "#process" },
  { label: "Priskalkylator", href: "#kalkylator" },
  { label: "Guider", href: "/guider" },
  { label: "Omdömen", href: "#omdomen" },
  { label: "FAQ", href: "#faq" },
];

export const roofColors = [
  { id: "svart", label: "Svart", hex: "#1e1e1e", img: "https://static.prod-images.emergentagent.com/jobs/e1d0720d-028d-413f-a9e1-4e1817879df4/images/eb6943e27934623d25c98bea7fc3efcb805b2fe5eaf4cd1ee26792de02e5f59b.jpeg" },
  { id: "gra", label: "Grå", hex: "#808589", img: "https://static.prod-images.emergentagent.com/jobs/e1d0720d-028d-413f-a9e1-4e1817879df4/images/99b575ae5b09bfd5d76bc08f17fb3fbfbbff415e279a73f26b8c793e22d2d99c.jpeg" },
  { id: "tegelrod", label: "Tegelröd", hex: "#b04a30", img: "https://static.prod-images.emergentagent.com/jobs/e1d0720d-028d-413f-a9e1-4e1817879df4/images/0c1140639d700ecb4e9868c0bf6f362dea4310885e9ab9b6790096bba229083b.jpeg" },
  { id: "specialrod", label: "Specialröd", hex: "#b83227", img: "https://static.prod-images.emergentagent.com/jobs/e1d0720d-028d-413f-a9e1-4e1817879df4/images/7b7abd3d117423f3ef922f3517dbc13bff8ddbc3da832c6db06d95810a9691f2.jpeg" },
  { id: "morkantracit", label: "Mörk antracit", hex: "#2c3035", img: "https://static.prod-images.emergentagent.com/jobs/e1d0720d-028d-413f-a9e1-4e1817879df4/images/f948937cb737b6d50beb8341d23b1fd12ba1e4aadeb94a1d2c1ce978719adff8.jpeg" },
  { id: "oxiderad", label: "Oxiderad", hex: "#6b3327", img: "https://static.prod-images.emergentagent.com/jobs/e1d0720d-028d-413f-a9e1-4e1817879df4/images/cba525bf4957e19a26e29d782eb50b627750c1d17fa93b49a39185fad7c83ba5.jpeg" },
  { id: "morkbrun", label: "Mörkbrun", hex: "#3e2b1f", img: "https://static.prod-images.emergentagent.com/jobs/e1d0720d-028d-413f-a9e1-4e1817879df4/images/5ffaa9a0fd45891df16a82cb34f19207d792cf4ca44372a384f79d792f690cc8.jpeg" },
  { id: "morkgra", label: "Mörk grå", hex: "#4a4f55", img: "https://static.prod-images.emergentagent.com/jobs/e1d0720d-028d-413f-a9e1-4e1817879df4/images/37f4ca850639d682185b7b9482c21f7d76466acee9c0aaacef62d38a08ca5d6e.jpeg" },
];

export const facadeColors = [
  { id: "behall", label: "Behåll nuvarande", hex: "#e2e8f0", value: null },
  { id: "vit", label: "Vit", hex: "#f5f5f2", value: "vit" },
  { id: "ljusgra", label: "Ljusgrå", hex: "#c7ccd1", value: "ljusgrå" },
  { id: "gra_f", label: "Grå", hex: "#8b9096", value: "grå" },
  { id: "falurod", label: "Falu röd", hex: "#8a3324", value: "falu röd" },
  { id: "gul", label: "Gul", hex: "#e3c56b", value: "varmt gul" },
  { id: "beige", label: "Beige", hex: "#d9cbb2", value: "beige" },
  { id: "svart_f", label: "Svart", hex: "#22252a", value: "svart" },
];

export const segments = [
  "Villaägare",
  "BRF",
  "Företag",
  "Fastighetsägare",
  "Samfälligheter",
];

export const stats = [
  { number: 24, label: "Anställda takproffs", text: "Vi anställer våra egna hantverkare – inga mellanhänder, alltid rätt utfört." },
  { number: 8, label: "År i branschen", text: "Lång erfarenhet av tak i alla former – tegel, betong, plåt och eternit." },
  { number: 2600, label: "Rengjorda & målade tak", text: "Cirka 2 600 tak i Sverige, alltid med full kontroll från första besiktning." },
];

export const trustLogos = [
  "HSB", "Riksbyggen", "Svenska Kyrkan", "Catena", "Willhem", "Balder", "Wallenstam",
];

export const services = [
  {
    id: "taktvatt",
    icon: Droplets,
    tag: "Populärast",
    title: "Taktvätt",
    price: "Kampanj fr. 11 920 kr",
    desc: "Skonsam mjuktvätt som tar bort mossa, alger och lav – förlänger takets livslängd utan högtryck som skadar pannorna.",
    points: ["20% kampanjrabatt", "Skonsam mjuktvätt", "100–125 kr/m² ord. pris"],
    image: "/taktvatt.webp",
  },
  {
    id: "kombi",
    icon: Layers,
    tag: "Bäst värde",
    title: "Taktvätt + Takmålning",
    price: "Kampanj 21 280–63 840 kr",
    desc: "Komplett paket: vi tvättar taket och målar det med marknadens bästa färg. Ger taket nytt liv, bättre skydd och ett resultat som håller i årtionden.",
    points: ["20% kampanjrabatt", "10 års garanti", "För lämpliga betongtak"],
    image: "/takmalning.webp",
  },
  {
    id: "solcellstvatt",
    icon: Sun,
    tag: "Fast paketpris",
    title: "Solcellstvätt",
    price: "Kampanj fr. 2 799 kr",
    desc: "Rena solpaneler ger upp till 20% högre effekt. Vi tvättar skonsamt med avjoniserat vatten – utan repor eller kemikalier. Fasta paketpriser.",
    points: ["20% kampanjrabatt", "Avjoniserat vatten", "Skonsam rengöring"],
    image: "/solceller.png",
    link: "/solcellstvatt",
  },
  {
    id: "nocktatning",
    icon: Wrench,
    tag: "Skydd",
    title: "Nocktätning",
    price: "Kampanj fr. 240 kr/m",
    desc: "Vi tätar takets nock med rätt material så väta, fukt och skadedjur hålls ute. Ett prisvärt skydd som förlänger takets livslängd – pris per löpmeter, efter ROT-avdrag.",
    points: ["20% kampanjrabatt", "Tätar mot väta & djur", "240–360 kr/m efter ROT"],
    image: "/nocktatning.webp",
  },
];

export const solarPackages = [
  { name: "Paket 1", panels: "Upp till 20 paneler", price: "3 499 kr", popular: false },
  { name: "Paket 2", panels: "20–30 paneler", price: "3 999 kr", popular: true },
  { name: "Paket 3", panels: "30–40 paneler", price: "4 499 kr", popular: false },
  { name: "Paket 4", panels: "40–50 paneler", price: "4 999 kr", popular: false },
];

export const solarBenefits = [
  { icon: Sparkles, title: "Upp till 20% mer effekt", text: "Smuts, pollen och fågelspillning sänker produktionen. Rena paneler jobbar för fullt igen." },
  { icon: Droplets, title: "Avjoniserat vatten", text: "Vi tvättar med rent, avjoniserat vatten – inga kemikalier, inga fläckar." },
  { icon: ShieldCheck, title: "Repfritt & säkert", text: "Skonsam metod och rätt utrustning skyddar både paneler och tak." },
  { icon: Leaf, title: "Miljövänligt", text: "Helt kemikaliefritt – bra för din anläggning och för naturen." },
];

export const usps = [
  { icon: ShieldCheck, title: "Egna certifierade team", text: "Inga underleverantörer – våra egna proffs gör jobbet." },
  { icon: Leaf, title: "Miljövänliga metoder", text: "Biologiskt nedbrytbara medel och skonsam mjuktvätt." },
  { icon: Sparkles, title: "Garanterat resultat", text: "Nöjd-kund-garanti och 10 års garanti på takmålning." },
];

export const steps = [
  { icon: ClipboardList, title: "1. Fyll i formuläret", text: "Berätta om ditt tak på några minuter – det är kostnadsfritt och utan förbindelse." },
  { icon: PhoneCall, title: "2. Fri besiktning", text: "Vi hör av oss inom en arbetsdag, besiktigar taket och tar fram en tydlig offert." },
  { icon: Wrench, title: "3. Vi utför jobbet", text: "Våra egna takproffs tvättar och/eller målar taket – snyggt, säkert och i tid." },
  { icon: Headphones, title: "4. Uppföljning", text: "Vi följer upp resultatet och finns här för dig med råd och garanti." },
];

export const gallery = [
  {
    title: "Villa – Taktvätt av mossbeklätt betongtegeltak",
    tjanst: "Taktvätt",
    taktyp: "Betongtegel",
    ort: "Stockholms län",
    before: "/before-after/taktvatt-before-aligned.jpg",
    after: "/before-after/taktvatt-after.jpg",
  },
  {
    title: "Villa – Takmålning i svart",
    tjanst: "Taktvätt + takmålning",
    taktyp: "Betongtegel",
    ort: "Stockholms län",
    before: "/before-after/takmalning-before.jpg",
    after: "/before-after/takmalning-after-aligned.jpg",
  },
];

export const testimonials = [
  { name: "Anna Bergström", city: "Stockholm", rating: 5, text: "Otroligt nöjd! Taket ser ut som nytt igen. Proffsigt bemötande från första kontakt till färdigt jobb." },
  { name: "Johan Lindqvist", city: "Täby", rating: 5, text: "HPR tvättade och målade vårt tak på några dagar. Resultatet är fantastiskt och priset var precis som utlovat." },
  { name: "Sara Nilsson", city: "Uppsala", rating: 5, text: "Bokade taktvätt och solcellstvätt samtidigt. Panelerna producerar märkbart mer nu. Rekommenderas varmt!" },
  { name: "Mikael Ek", city: "Nacka", rating: 5, text: "Belevade, punktliga och noggranna. Skötte allt själva. Känns tryggt att anlita ett riktigt proffsgäng." },
];

export const areas = [
  "Stockholm", "Solna", "Sundbyberg", "Nacka", "Täby", "Sollentuna",
  "Danderyd", "Lidingö", "Järfälla", "Huddinge", "Upplands Väsby", "Sigtuna",
  "Vallentuna", "Österåker", "Norrtälje", "Södertälje",
  "Uppsala", "Enköping", "Knivsta", "Håbo", "Tierp", "Östhammar",
];

export const faqs = [
  { q: "Skadar inte högtryck taket?", a: "Vi använder i första hand skonsam mjuktvätt (lågtryck) med biologiskt nedbrytbara medel. Det tar effektivt bort mossa och alger utan att skada takpannorna – till skillnad från aggressiv högtryckstvätt." },
  { q: "Hur lång tid tar en taktvätt?", a: "En normalstor villa tar oftast 1 dag för tvätt. Vid takmålning tillkommer torktid och målning, vilket brukar ta 2–4 dagar beroende på väder och takets storlek." },
  { q: "Hur länge håller en takmålning?", a: "Med vår process (grundning + två strykningar kvalitetsfärg) håller resultatet normalt 10–15 år. Vi lämnar 10 års garanti på utfört målningsarbete." },
  { q: "Kan jag få ROT-avdrag?", a: "Ja, arbetskostnaden för taktvätt och takmålning är oftast ROT-berättigad för privatpersoner. Vi drar av det direkt på din faktura och sköter administrationen." },
  { q: "Vad kostar solcellstvätt?", a: "Vi har fasta paketpriser från 3 499 kr beroende på antal paneler. Se alla paket på vår solcellstvätt-sida – enkelt och utan överraskningar." },
  { q: "Vad kostar taktvätt och takmålning?", a: "Taktvätt börjar från 14 900 kr (ca 100–125 kr/m²) och kombipaketet taktvätt + takmålning ligger på 26 600–79 800 kr beroende på takets storlek och skick. Fyll i formuläret för en exakt offert." },
];

export const contactTabs = ["Privat", "BRF", "Företag", "Fastighetsägare"];
